import { useEffect as r } from "react";
import { useCalendarContext as t } from "./atoms-v2766.js";
function u() {
  const { dataManager: o, domBuilder: a } = t();
  r(() => {
    a.calendarYearConfigs.forEach((e) => {
      o.addBatchToQueue(e.value, e.month.value);
    });
  }, [a.calendarYearConfigs]);
}
export {
  u as useDataPreloader
};
